/* product-page.js */

document.addEventListener("DOMContentLoaded", () => {
  initGallery();
  initLightbox();
  initStickyAtc();
  initVariantPicker();
  initQtyStepper();
  loadAsyncSections();
});

function initGallery() {
  const gallery = document.querySelector("[data-product-gallery]");
  if (!gallery) return;
  const thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
  const mainSlides = gallery.querySelectorAll("[data-gallery-slide]");

  thumbs.forEach(thumb => {
    thumb.addEventListener("click", () => {
      const index = parseInt(thumb.dataset.index, 10);
      mainSlides.forEach((s, i) => s.classList.toggle("active", i === index));
      thumbs.forEach(t => t.classList.remove("active"));
      thumb.classList.add("active");
    });
  });
}

function initLightbox() {
  const modal = document.querySelector("[data-lightbox]");
  if (!modal) return;
  const triggers = document.querySelectorAll("[data-gallery-zoom]");
  const images = modal.querySelectorAll("[data-lightbox-img]");
  let current = 0;

  function show(index) {
    current = (index + images.length) % images.length;
    images.forEach((img, i) => {
      img.hidden = i !== current;
    });
  }

  function open(index) {
    show(index);
    modal.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function close() {
    modal.hidden = true;
    document.body.style.overflow = "";
  }

  triggers.forEach(trigger => {
    trigger.addEventListener("click", () => {
      open(parseInt(trigger.dataset.index, 10) || 0);
    });
  });

  modal.querySelectorAll("[data-lightbox-close]").forEach(btn => {
    btn.addEventListener("click", close);
  });
  modal.querySelector("[data-lightbox-prev]")?.addEventListener("click", () => show(current - 1));
  modal.querySelector("[data-lightbox-next]")?.addEventListener("click", () => show(current + 1));

  document.addEventListener("keydown", (e) => {
    if (modal.hidden) return;
    if (e.key === "Escape") close();
    if (e.key === "ArrowLeft") show(current - 1);
    if (e.key === "ArrowRight") show(current + 1);
  });
}

function initStickyAtc() {
  const bar = document.querySelector("[data-sticky-atc]");
  const anchor = document.querySelector("[data-add-to-cart]");
  const stickyBtn = bar?.querySelector("[data-sticky-add]");
  if (!bar || !anchor) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        bar.hidden = entry.isIntersecting;
      });
    },
    { threshold: 0 }
  );
  observer.observe(anchor);

  stickyBtn?.addEventListener("click", () => anchor.click());
}

function initVariantPicker() {
  const form = document.querySelector("[data-product-form]");
  if (!form) return;

  const variantInput = form.querySelector("[data-variant-id]");
  const priceEl = document.querySelector("[data-product-price]");
  const stickyPriceEl = document.querySelector("[data-sticky-price]");
  const skuEl = document.querySelector("[data-sku]");
  const stockEl = document.querySelector("[data-stock-status]");
  const addBtn = form.querySelector("[data-add-to-cart]");
  const optionGroups = form.querySelectorAll("[data-option-index]");

  // Product JSON is needed for real variant matching — read it from the
  // handle and fetch once, cached for the life of the page.
  const handle = document.body.dataset.productHandle || document.querySelector("[data-product-handle]")?.dataset.productHandle;
  let productData = null;

  fetch(`/products/${handle}.js`).then(r => r.json()).then(data => {
    productData = data;
    wireOptions();
  });

  function wireOptions() {
    const selections = {};

    optionGroups.forEach(group => {
      const idx = group.dataset.optionIndex;
      const buttons = group.querySelectorAll(".qv-option-btn, .swatch-btn");
      buttons[0]?.classList.add("selected");
      selections[idx] = buttons[0]?.dataset.value;

      buttons.forEach(btn => {
        btn.addEventListener("click", () => {
          buttons.forEach(b => b.classList.remove("selected"));
          btn.classList.add("selected");
          selections[idx] = btn.dataset.value;
          updateVariant(selections);
        });
      });
    });

    updateVariant(selections);
  }

  function updateVariant(selections) {
    if (!productData) return;
    const match = productData.variants.find(v =>
      Object.keys(selections).every(i => v[`option${parseInt(i) + 1}`] === selections[i])
    );
    if (!match) return;

    variantInput.value = match.id;
    if (skuEl) skuEl.textContent = `SKU: ${match.sku || ""}`;

    const money = (cents) => (cents / 100).toLocaleString(undefined, { style: "currency", currency: window.Shopify?.currency?.active || "PKR" });
    const onSale = match.compare_at_price > match.price;
    const pct = onSale ? Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100) : 0;
    const priceHtml = `${onSale ? `<span class="pct">-${pct}%</span><span class="new">${money(match.price)}</span><span class="old">${money(match.compare_at_price)}</span>` : `<span class="new">${money(match.price)}</span>`}`;
    if (priceEl) priceEl.innerHTML = priceHtml;
    if (stickyPriceEl) stickyPriceEl.innerHTML = `${onSale ? `<span class="old">${money(match.compare_at_price)}</span>` : ""}<span class="new">${money(match.price)}</span>`;

    if (match.available) {
      stockEl.textContent = "In stock";
      stockEl.classList.remove("out-of-stock");
      addBtn.disabled = false;
      addBtn.textContent = "Add to Cart";
    } else {
      stockEl.textContent = "Out of stock";
      stockEl.classList.add("out-of-stock");
      addBtn.disabled = true;
      addBtn.textContent = "Sold Out";
    }
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    addBtn.textContent = "Adding…";
    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantInput.value,
          quantity: parseInt(form.querySelector("[data-qty-input]").value, 10) || 1
        })
      });
      document.dispatchEvent(new CustomEvent("cart:updated"));
      addBtn.textContent = "Added ✓";
      setTimeout(() => { addBtn.textContent = "Add to Cart"; }, 1500);
    } catch (err) {
      addBtn.textContent = "Try again";
      console.error(err);
    }
  });
}

function initQtyStepper() {
  document.querySelectorAll(".qty-stepper").forEach(stepper => {
    const input = stepper.querySelector("[data-qty-input]");
    stepper.querySelector("[data-qty-increase]")?.addEventListener("click", () => {
      input.value = Math.max(1, parseInt(input.value || 1, 10) + 1);
    });
    stepper.querySelector("[data-qty-decrease]")?.addEventListener("click", () => {
      input.value = Math.max(1, parseInt(input.value || 1, 10) - 1);
    });
  });
}

/* Loads sections async via the Section Rendering API — used for product
   recommendations so they don't block the initial product page render. */
function loadAsyncSections() {
  document.querySelectorAll("[data-section-loader]").forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const wrapper = document.createElement("div");
      wrapper.innerHTML = html;
      el.replaceWith(...wrapper.childNodes);
    } catch (err) {
      console.error("Failed to load section", err);
    }
  });
}
